import { FC } from 'react'

interface CardHeaderProps {
    current: number,
    max: number
}

export const CardHeader: FC<CardHeaderProps> = ({ current = 0, max = 0 }) => {
    const percent = max > 0 ? (current / max) * 100 : 0

    return (
        <>
            <div className='test-area__header'>
                <div id='counter'>{`${current} / ${max}`}</div>
            </div>
            <div className='test-progress-bar'>
                <div
                    className='test-progress-bar__fill'
                    style={{ width: `${percent}%` }}
                />
            </div>
        </>
    )
}
